import {Component, OnInit} from '@angular/core';
import {Service} from "../../../Models/service";
import {ActivatedRoute, Router} from "@angular/router";
import {ServiceService} from "../../../Services/service.service";
import {environment} from "../../../../environments/environment" ;
import {EmailsService} from "../../../Services/emails.service";
import {ToastrService} from "ngx-toastr";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-show-power-bi',
    templateUrl: './show-power-bi.component.html',
    styleUrls: ['./show-power-bi.component.scss']
})
export class ShowPowerBiComponent implements OnInit {
    projectId = '';
    email: any;
    haveAccess = false;
    url:any;

    constructor(private activatedRoute: ActivatedRoute, private emailServ: EmailsService,
                private toastr: ToastrService, private route: Router , public sanitizer: DomSanitizer ) {
    }

    ngOnInit(): void {
        this.projectId = this.activatedRoute.snapshot.paramMap.get('id');
        this.emailServ.getAccessByProject(this.projectId).subscribe(data => {
            this.haveAccess = data.succeeded;
            if (data.succeeded) {
                this.email = data.data;
                this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.email.linkProject);

            }
            else {
                this.toastr.error("Sorry.... You don't have access for this page", "Not Authorized")
                return this.route.navigateByUrl("/home")
            }

        });
    }

    protected readonly environment = environment;
}
